Ext.define('SA.data.ExpectedCounterpartAttribute', {
    statics: {
        create(values) {
            return new SA.data.ExpectedCounterpartAttribute(values);
        }
    },

    constructor(values) {
        this.values = values;
    },

    fetchId() {
        var {type, name, country, censusRelease, year, group} = this.values;

        return SA.AttributesQueryBuilder.create()
            .field('attribute')
            .censusRelease({country, censusRelease})
            .group(group)
            .year(year)
            .type(type)
            .name(name)
            .statusVisible()
            .limit(1)
            .run();
    },

    isCount() {
        return this.values.type === 'count';
    },

    isMatch({attribute}) {
        attribute = SA.data.AttributesCache.get(attribute);

        return Object.entries(this.values).every(([field, value]) => value === attribute[field]);
    }
});